import SurveysList from './SurveysList'
export {SurveysList}
export default SurveysList
